"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
function BlogListConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-[var(--radius-md)] bg-muted/20 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground mb-4">Failed to load blog posts.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No blog posts available at this time.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group">
          <Card className="h-full flex flex-col overflow-hidden hover-lift border-none shadow-soft">
            {post.featuredImage && <div className="relative h-64 overflow-hidden">
                <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-[300ms] ease-smooth group-hover:scale-[1.03]" />
              </div>}
            <CardHeader>
              <CardTitle className="text-xl font-display font-semibold tracking-tight leading-tight text-foreground">
                {post.title}
              </CardTitle>
            </CardHeader>
            <CardContent className="flex-1 flex flex-col gap-4">
              {post.excerpt && <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3">
                  {post.excerpt.replace(/<[^>]*>/g, "")}
                </p>}
              {post.link && <Link to={post.link} className="inline-flex items-center gap-2 text-sm font-sans font-semibold text-accent hover:text-accent-hover transition-colors duration-fast mt-auto group/link">
                  Read More
                  <ArrowRight className="size-4 transition-transform duration-fast ease-spring group-hover/link:translate-x-1" />
                </Link>}
            </CardContent>
          </Card>
        </article>)}
    </div>;
}
export default function BlogList() {
  return <section id="blog-list" className="dark bg-background text-foreground py-16 md:py-24 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-display font-semibold tracking-tight leading-tight mb-4">
            The French Budget Hack
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover savvy tips and tricks for budget travel across France
          </p>
        </div>
        <PostsProvider className="blog-list-provider" wp_query={{
        per_page: 9,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia", "author"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "date", "_embedded", "_links.wp:featuredmedia", "_links.author"]}>
          <BlogListConsumer />
        </PostsProvider>
      </div>
    </section>;
}